import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

export async function loginWithDocument(document) {
  const { data } = await api.post("/auth/login", { document });
  return data;
}

export async function validateDocument(document) {
  const { data } = await api.post("/auth/validate", { document });
  return data;
}

export async function searchPlaces({ lat, lng, service, radius_m = 15000, document }) {
  const { data } = await api.post("/places/search", { lat, lng, service, radius_m, document });
  return data;
}

export async function getPlaceDetails(placeId) {
  const { data } = await api.get(`/places/${encodeURIComponent(placeId)}`);
  return data;
}

export async function getPlaceSummary(placeId, service) {
  const { data } = await api.get(`/places/${encodeURIComponent(placeId)}/summary`, {
    params: service ? { service } : {},
  });
  return data;
}

export async function reverseGeocode(lat, lng) {
  const { data } = await api.get(`/geocode/reverse`, { params: { lat, lng } });
  return data;
}

export async function searchGeocode(query) {
  const { data } = await api.get(`/geocode/search`, { params: { q: query } });
  return data;
}

